import React, { useEffect, useState } from 'react';
import Button from '../../../../../shared/components/Button/Button';
import Checkbox from '../../../../../shared/components/Checkbox/Checkbox';
import Input from '../../../../../shared/components/Input/Input';
import Dialog from '../../../../../shared/components/Dialog/Dialog';

const isValidUrl = (value = '') => /^(https?:\/\/|mailto:|tel:|#|\/)/i.test(value.trim());

function WikiLinkDialog({
  initialNewTab = true,
  initialText = '',
  initialUrl = '',
  open,
  onClose,
  onRemove,
  onSubmit,
}) {
  const [url, setUrl] = useState(initialUrl);
  const [text, setText] = useState(initialText);
  const [openInNewTab, setOpenInNewTab] = useState(initialNewTab);

  useEffect(() => {
    if (open) {
      setUrl(initialUrl || '');
      setText(initialText || '');
      setOpenInNewTab(initialNewTab);
    }
  }, [initialNewTab, initialText, initialUrl, open]);

  const hasError = Boolean(url.trim()) && !isValidUrl(url);
  const submit = () => {
    onSubmit({
      href: url.trim(),
      target: openInNewTab ? '_blank' : null,
      text: text.trim(),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Lien"
      actions={(
        <>
          <Button variant="danger" onClick={onRemove}>Supprimer</Button>
          <Button variant="tertiary" onClick={onClose}>Annuler</Button>
          <Button
            variant="primary"
            disabled={!url.trim() || hasError}
            onClick={submit}
          >
            Appliquer
          </Button>
        </>
      )}
    >
        <Input
          fullWidth
          label="Texte selectionne"
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder="Texte du lien"
        />
        <Input
          autoFocus
          fullWidth
          label="URL"
          value={url}
          aria-invalid={hasError}
          onChange={(event) => setUrl(event.target.value)}
        />
        <small className={hasError ? 'wiki-dialog-help error' : 'wiki-dialog-help'}>
          {hasError ? 'Utilise une URL http(s), mailto, tel, /chemin ou #ancre.' : 'Architecture prête pour relier plus tard un article Wiki, un document GED ou un projet ERP.'}
        </small>
        <Checkbox
          checked={openInNewTab}
          label="Ouvrir dans un nouvel onglet"
          onChange={(event) => setOpenInNewTab(event.target.checked)}
        />
    </Dialog>
  );
}

export default WikiLinkDialog;
